import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { Ge as d, hi as h, bo as s, w as m, M as l, fi as u } from "./abstract-base-8edf0a84-e11d45a3.js";
var g = d(_templateObject || (_templateObject = _taggedTemplateLiteral(["div{line-height:var(--beacon-headline-font-line-height-module-50);padding-block-end:var(--beacon-table-caption-spacer-default);font-size:var(--beacon-headline-font-size-50);font-weight:var(--beacon-font-weight-bold)}.table-caption{padding-block-end:var(--beacon-table-caption-spacer-jumbo)}span{display:block;font-size:var(--beacon-caption-font-size-300);line-height:var(--beacon-caption-font-line-height-module-300);padding-block-end:var(--beacon-table-caption-summary-spacer)}\n"])));
var v = Object.defineProperty,
  f = Object.getOwnPropertyDescriptor,
  p = function p(n, e, o, a) {
    for (var t = a > 1 ? void 0 : a ? f(e, o) : e, i = n.length - 1, r; i >= 0; i--) (r = n[i]) && (t = (a ? r(e, o, t) : r(t)) || t);
    return a && t && v(e, o, t), t;
  };
var b = "beacon-table-caption";
var c = /*#__PURE__*/function (_h) {
  _inherits(c, _h);
  function c() {
    var _this;
    _classCallCheck(this, c);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(c).apply(this, arguments)), _this.beaconTagName = b, _this.caption = "", _this.summary = "";
    return _this;
  }
  _createClass(c, [{
    key: "render",
    value: function render() {
      return s(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<div class=", ">", "</div>\n      ", ""])), this.summary ? "" : "table-caption", this.caption, this.summary ? s(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<span>", "</span>"])), this.summary) : m);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(c.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(c), "styles", this), g];
    }
  }]);
  return c;
}(h(u));
c.tagName = b;
p([l()], c.prototype, "caption", 2);
p([l()], c.prototype, "summary", 2);
export { c as BeaconTableCaption };